'use client'

import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { apiInstance } from '@/apiInstance'
import { RoutePath } from '@/routes'

export default function LoginForm() {
  const navigate = useNavigate()
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    loginWithClient()
  })

  async function loginWithClient() {
    try {
      setIsLoading(true)
      const token = await apiInstance.loginWithClient()
      if (token) {
        // Get redirect path from localStorage
        const redirectTo = localStorage.getItem('redirectTo')
        if (redirectTo) {
          localStorage.removeItem('redirectTo') // Clear it after use
          navigate(redirectTo, { replace: true })
        } else {
          navigate(RoutePath.HOME, { replace: true })
        }
      }
    } catch (error: any) {
      let errorMessage
      if (error?.status === 401) {
        errorMessage = 'Error - Invalid client id and secret'
      } else {
        errorMessage =
          error?.data?.message || error?.message || 'An error occurred. Please try again.'
      }
      setError(errorMessage)
      setIsLoading(false)
    }
  }

  return (
    <div className="container flex items-center justify-center min-h-screen">
      {isLoading ? (
        <div className="text-center">
          <p className="text-lg">...</p>
        </div>
      ) : (
        <>
          {error && <span className="text-red-500 block mb-4">{error}</span>}
          <div className="text-center">
            <p className="text-lg">Please wait while we authenticate you...</p>
          </div>
        </>
      )}
    </div>
  )
}
